<template>
  <div class="index" :td-event="td">
    <div class="header acea-row row-center-wrapper">
      <router-link :to="'/search'" class="search acea-row row-middle"> <span class="iconfont icon-xiazai5"></span>搜索商品 </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0" ref="mySwiper" >
        <swiper-slide v-for="(item, i) in banner" :key="i">
          <router-link :to="item.wap_url">
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <!-- <span class="speaker-icon">🔊</span>  -->
     <div style="display: flex;" class="bannerBtm">
        <!-- <div class="laba" style="margin-top: 11px;margin-right: 8px;margin-left:5px">🔊</div>
        <div class="marquee">
      
          <span>尊敬的客户：国庆期间，部分商品10月9日发货~</span>
          
        </div> -->
        <img src="https://bank.giftoceanmall.com/65f62202604211026044658.jpeg" alt="">
     </div>
    
    <div class="wrapper" v-if="info.fastList.length > 0">
      <!-- <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">快速选择</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="'/category'" class="more">更多<span class="iconfont icon-jiantou"></span></router-link>
      </div> -->
      <div class="scroll-product category-wrapper">
        <swiper class="swiper-container" :options="categorySwiperOption">
          <swiper-slide v-for="(group, groupIndex) in groupedList" :key="groupIndex">
            <div class="grid-container">
              <span v-for="(item, index) in group" :key="index" class="grid-item">
                <router-link v-if="item.customize_url" :to="{ path: item.customize_url }">
                  <div class="img-box">
                    <img style="width: 50px; height: 50px;" v-lazy="item.pic" alt="img" />
                  </div>
                  <div class="pro-info line1">{{ item.cate_name }}</div>
                </router-link>
                <router-link
                  v-else
                  :to="{
                    path: '/goods_list',
                    query: { id: item.id, title: item.cate_name },
                  }"
                >
                  <div class="img-box">
                    <img style="width: 50px; height: 50px;" v-lazy="item.pic" alt="img" />
                  </div>
                  <div class="pro-info line1">{{ item.cate_name }}</div>
                </router-link>
              </span>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div style="width:100%;" class="swiper-pagination categoryPaginationBanner"></div>
    </div>
    <div class="wrapper" v-if="info.bastList.length > 0 || info.bastBanner.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more">更多<span class="iconfont icon-jiantou"></span></router-link>
      </div>
      <div class="slider-banner boutique">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide class="swiper-slide" v-for="(item, i) in info.bastBanner" :key="i">
            <router-link :to="item.wap_link ? item.wap_link : ''"><img :src="item.img"/></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div>
      <div class="productList" style="background:#f5f5f5;" ref="container">
        <div class="list acea-row row-between-wrapper" style="margin-top:0.2rem !important;" :class="Switch === true ? '' : 'on'" ref="container">
          <div @click="goDetail(item)" v-for="(item, index) in info.bastList" :key="index" class="item" :class="Switch === true ? '' : 'on'" :title="item.store_name">
            <div class="pictrue" :class="Switch === true ? '' : 'on'">
              <img style="position:absolute;right: 0;" :src="item.image" :class="Switch === true ? '' : 'on'" />
              <div class="icon-mianxi">
                <span>{{ item.fenqi_num }}期</span>
                <span>免息</span>
              </div>
              <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '1'">秒杀</span>
              <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '2'">砍价</span>
              <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '3'">拼团</span>
            </div>
            <div class="text" :class="Switch === true ? '' : 'on'">
              <div class="name store-name">{{ item.store_name }}</div>
              <div class="money font-color-red" :class="Switch === true ? '' : 'on'">
                ￥<span class="num">{{ item.fenqi_price }}</span>
                <span style="color: black; font-weight: normal; font-size: 0.26rem;"> /期起</span>
              </div>
              <div style="font-size:0.3rem;color:#ccc;" :class="Switch === true ? '' : 'on'">
                ￥<span class="num">{{ item.price }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="height:1.5rem;"></div>
      </div>
    </div>
    <div v-if="newGoodsBananr">
      <div class="adver">
        <img v-lazy="newGoodsBananr" alt="img" />
      </div>
    </div>
    <div>
      <iframe v-if="mapKey && !isWeixin" ref="geoPage" width="0" height="0" frameborder="0" scrolling="no" :src="'https://apis.map.qq.com/tools/geolocation?key=' + mapKey + '&referer=myapp'"> </iframe>
    </div>
    <van-popup v-model="show" lock-scroll :close-on-click-overlay="false" style="border-radius: 10px">
      <div class="show-outer">
        <div class="show-box">
          <div class="title">提示</div>
          <div class="content">
            <span>您即将访问的页面及服务由</span>
            <span class="gs">海尔精选商城（海礼网（北京）智能技术有限公司）</span>
            <span>提供，如有问题请咨询该公司客服（客服电话：400-6777159）</span>
          </div>
          <div>
            <van-checkbox v-model="checked">已知晓，不再提示此信息</van-checkbox>
          </div>
        </div>
        <div class="operate">
          <span class="off" @click="handleOff" td-event="2668004TP001">取消</span>
          <span class="go" @click="handleGo" td-event="2668004TP002">继续访问</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare, follow } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
import { orderPayStatus } from "@api/order";
import Vue from "vue";
import { Popup, Checkbox, CheckboxGroup } from "vant";

Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {
    Swiper,
    SwiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow,
  },
  props: {},
  data: function() {
    return {
      id: "",
      Switch: true,
      checked: false,
      show: false,
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      categorySwiperOption: {
        pagination: {
          el: ".categoryPaginationBanner",
          clickable: true,
        },
        loop: false,
      },
      swiperOption: {
        spaceBetween: 10,
        pagination: {
          el: ".paginationBanner",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          },
        },
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1500,
        observer: true,
        observeParents: true,
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
      },
      mapKey: "",
    };
  },
  computed: {
    groupedList() {
      // 每页8个，分组展示
      const itemsPerPage = 8;
      const result = [];
      for (let i = 0; i < this.info.fastList.length; i += itemsPerPage) {
        result.push(this.info.fastList.slice(i, i + itemsPerPage));
      }
      return result;
    },
  },
  created() {
    vm = this;
  },
  mounted: function() {
    // const datas = {
    //   token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ3d3cuZ2lmdG9jZWFubWFsbC5jb20iLCJhdWQiOiJ3d3cuZ2lmdG9jZWFubWFsbC5jb20iLCJpYXQiOjE3NTQ5MTE3MjAsIm5iZiI6MTc1NDkxMTcyMCwiZXhwIjoxNzU0OTIyNTIwLCJqdGkiOnsiaWQiOjIsInR5cGUiOiJ1c2VyIn19.-vZzvqb3nrMGbB_2EmbIzsRjDSpVXkC6yTI0E08KZUE",
    //   expires_time: "2025-08-12 18:12:15",
    // };
    // this.$store.commit("LOGIN", datas);

    this.getFollow();
    let that = this;
    that.id = this.$route.params.id;
    getHomeData().then((res) => {
      that.mapKey = res.data.tengxun_map_key;
      cookie.set(MAPKEY, that.mapKey);
      that.logoUrl = res.data.logoUrl;
      that.newGoodsBananr = res.data.newGoodsBananr;
      //console.log(res.data.banner);
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(that, "lovely", res.data.lovely.length ? res.data.lovely[0] : {});
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.subscribe = res.data.subscribe;
      if (!that.subscribe && that.followUrl) {
        setTimeout(function() {
          that.followHid = true;
        }, 200);
      } else {
        that.followHid = false;
      }
      if (res.data.site_name) document.title = res.data.site_name;
      that.setOpenShare();
      this.showCoupon = !cookie.has(HAS_COUPON_WINDOW) && res.data.couponList.some((coupon) => coupon.is_use);
      if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
    });

    //买单吧返回首页
    // if (that.id != undefined) {
    //   that.payStatus();
    // }
  },
  methods: {
    handleShare() {
      if (typeof srsCallNative === "function") {
        let parameters = {
          content: [
            {
              action: "share",
              title: "分享",
              para: {
                channel: "WX,Wechant",
                desc: "分享描述",
                imageUrl: "分享的图片地址",
                pageUrl: "分享的页面URL",
                title: "分享的标题",
              },
            },
          ],
        };

        window.hycb = () => {};
        srsCallNative("JSNative", parameters, "hycb");
      }
    },
    //取消（关闭浏览器）
    handleOff() {
      setTimeout(function() {
        window.location.href = "mdb://closeWebPage";
      }, 200);
    },
    //继续访问
    handleGo() {
      let value = {
        status: true,
        expires: Date.now() + 86400000,
      };
      if (this.checked == true) {
        value.expires = "";
        cookie.set("prompt_check", value);
      } else {
        cookie.set("prompt_check", value);
      }
      this.show = false;
    },

    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey) console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then((res) => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
    //更新订单支付状态
    payStatus() {
      orderPayStatus(this.id).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.store-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* 限制文本显示在2行 */
  word-break: break-all;
  overflow: hidden;
  /* 关键设置 */
  line-height: 1.5em;
  /* 设置单行行高 */
  min-height: 3em;
  /* 两行高度 = 行高 × 2 */
}

.icon-mianxi {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 0.7rem;
  height: 0.7rem;
  font-size: 0.22rem;
  color: #fff;
  background: #f00;
}

.index {
  background-color: #fff;

  .title-box {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: white;
    border-bottom: #f0f0f0 1px solid;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;

    .title-box:hover {
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
      /* 悬停时阴影变大 */
    }

    .title {
      margin: auto 0;
      letter-spacing: 1px;
    }

    .return {
      display: flex;
      flex-direction: row;
      align-items: center;

      .lg {
        width: 24px;
        height: 24px;
      }

      .close {
        font-size: 15px;
        margin-left: 10px;
      }
    }
  }

  .search {
    width: 7rem !important;
  }

  .follow {
    z-index: 999;
  }

  .keep {
    text-align: center;
  }
}

.categoryPaginationBanner {
  ::v-deep .swiper-pagination-bullet {
    width: 4px;
    height: 4px;
    border-radius: 100%;
    background: #fc4141;
    margin: 0 3px !important;
  }

  ::v-deep .swiper-pagination-bullet-active {
    background: #fc4141; // 设置为橙色
    width: 12px;
    border-radius: 4px;
  }
}

.category-wrapper {
  width: 100%;

  .swiper-slide {
    border-bottom: 0 !important;
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(4, calc(25% - 8px));
    grid-template-rows: repeat(2, 1fr);
    gap: 10px;
    margin: 0;
    padding: 0;
  }

  .grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    width: 100%;
  }

  .img-box {
    // width: 0;
    aspect-ratio: 1;
    height: 1.2rem !important;
    // margin-bottom: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 50px;
      height: 50px;
      object-fit: contain;
    }
  }

  .pro-info {
    font-size: 12px;
    color: #333;
    text-align: center;
    width: 100%;
    border: 0 !important;
  }
}
.bannerBtm{
  width: 100%;
  img{
    width: 100%;
  }
}
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.marquee {
  // position: absolute;
  color: #333;
  line-height: 0.5rem;
    overflow: hidden;
    white-space: nowrap;
    width:7.2rem;
    margin: 0.2rem auto;
    display: flex;
  }
  .marquee span {
    font-size: 0.22rem;
    animation: marquee 10s linear infinite;
    
  }
  @keyframes marquee {
    100% {transform: translateX(-100%);}
  }
  .speaker-icon {
    // position: relative;
    // margin-top: 100px;
    z-index: 10; /* 更高层级 */
    display: inline-block;

    background-color: #ff4d4f;

    color: white;

    border-radius: 50%;

    width: 16px;

    height: 16px;

    text-align: center;

    line-height: 16px;

    font-size: 10px;

    margin-right: 5px;

    }
</style>
